export enum PricePreviewType {
  DEFAULT = "DEFAULT",
  DISCOUNT_STRIKE_THROUGH = "DISCOUNT_STRIKE_THROUGH",
}

interface PricePreviewProps {
  type?: PricePreviewType
  originalPrice: number | string
  calculatedPrice?: number | string
}

export const PricePreview = ({ type = PricePreviewType.DEFAULT, originalPrice, calculatedPrice }: PricePreviewProps) => {
  return (
    <div className="flex flex-wrap items-baseline gap-x-2">
      <p className={`font-inter whitespace-nowrap ` + (type == PricePreviewType.DISCOUNT_STRIKE_THROUGH ? "font-normal text-[#AAAAAA] line-through" : "font-bold text-[#444444]")}>
        {originalPrice}
      </p>
      {type == PricePreviewType.DISCOUNT_STRIKE_THROUGH && !!calculatedPrice && (
        <p className="font-inter order-first font-bold whitespace-nowrap text-[#FF4344]">{calculatedPrice}</p>
      )}
    </div>
  )
}
